import logo from './logo.svg';
import './App.scss';
import InteractiveVideo from "./components/interactive-video";
import TheTitle from "./components/the-title";
import Postcard from "./components/postcard";
import React, {useState, createContext, useEffect} from "react";
import Credits from "./components/credits";
import {CardList, Cards} from "./cardList";


function App() {

    const [visible, setVisible] = useState(false);
    const [isPlaying, setIsPlaying] = useState(true);
    const [postcardVariant, setPostcardVariant] = useState(null);


    useEffect(() => {
        setViewportHeight();
        window.addEventListener('resize', setViewportHeight);
        document.addEventListener('keyup', escListener);
        return () => {
            document.removeEventListener('keyup', escListener);
            window.removeEventListener('resize', setViewportHeight);
        }
    })

    function escListener(e) {
        if (e.key === 'Escape') {
            setPostcardVariant(null);
            setIsPlaying(true);
        }
    }
    function setViewportHeight() {
        const vh = ((window.visualViewport.height ||  window.innerHeight ) - 10) * 0.01;
        console.log('vh: '+vh);
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    function handleClick(number) {
        console.log(number)
        // setVisible(true);
        setPostcardVariant(number);
        setIsPlaying(false);
    }

    function closePostcard() {
        setPostcardVariant(null);
        setIsPlaying(true);
    }

    return (
        <CardList.Provider value={Cards}>
        <div className="App">
            <div className='wrapper'>
                <img src='./assets/img/logo.png' id="logo"/>
                <InteractiveVideo play={isPlaying} onclick={handleClick}></InteractiveVideo>
                <TheTitle></TheTitle>
                <Postcard variant={postcardVariant} onClose={closePostcard}></Postcard>
                <Credits variant={postcardVariant}></Credits>
            </div>
        </div>
        </CardList.Provider>
    );
}

export default App;
